<template>
    <!-- 持仓分析 -->
    <div class="positionAnalysis">
        <el-row class="row-one mt30"><span class="subtitle">标的占比</span></el-row>
        <ul class="positionAnalysis-legend">
            <li><span></span>CTA策略</li>
            <li><span></span>股票多头</li>
            <li><span></span>流动性</li>
            <li><span></span>市场中性</li>
            <li><span></span>套利策略</li>
            <li><span></span>债券策略</li>
        </ul>
        <div class="mt20"><chart :option="optionBdzb" id="bdzb" style="width: 1160px;height: 450px;"></chart></div>
        <el-row class="row-one mt20"><span class="subtitle">策略占比</span></el-row>
        <div id="clzb" style="width: 1160px;height: 300px;"></div>
        <el-row class="row-one mt20"><span class="subtitle">策略占比面积图</span></el-row>
        <div><chart :option="optionLscw" id="clmj" style="width: 1160px;height: 450px;"></chart></div>
    </div>
</template>

<script>
import chart from "../../components/chart";
export default {
    name: "positionAnalysis",
    components:{
        chart
    },
    props: ['ProductInfo'],
    data() {
        return {
            optionBdzb: {
                title:{},
                grid: {top:'5%',left: '5%',right: '5%',bottom: '5%',containLabel: true},
                xAxis:{
                    type:'category',
                    data:[],
                    axisLabel:{fontSize:12,color: "#333",rotate:50},
                    axisLine:{lineStyle:{color: "#DDD"}},
                    boundaryGap: true,
                },
                yAxis:{
                    type:'value',
                    axisLabel: {
                        formatter:function (val){return (val*100).toFixed(2)+'%'},
                        fontSize:14,color:'#333'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter:function (params) {
                        var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>'+params[0].name+'</td><td></td></tr>';
                        for(let i=0;i<params.length;i++){
                            htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>标的占比：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                        }
                        htmlStr+='</table></div>';
                        return htmlStr;
                    }
                },
                series:[
                    {
                        name: 'CTA策略',
                        type: 'bar',barMaxWidth: 20,barMinWidth: 10,
                        data: [],
                        label: {
                            show: true,position: 'top',
                            formatter:function (val){return (val.value*100).toFixed(2)+'%'},
                        },
                    }
                ],
            },
            optionLscw:{
                title:{},
                color:['#4F81BD','#C0504D','#9BBB59','#8064A2','#4BACC6','#F79646'],
                legend:{
                    icon:'rect',itemWidth: 10,itemHeight: 10,bottom:20,itemGap:40,formatter:'{name}',textStyle:{fontSize:16,color:'#333',},pageIconColor: "#01567F",
                },
                grid: {top:'10%',left: '3%',right: '3%',bottom: '15%',containLabel: true},
                xAxis:{
                    type:'category',
                    data:[],
                    axisLabel:{fontSize:14,color: "#333",rotate:90},
                    axisLine:{lineStyle:{color: "#DDD"}},
                    boundaryGap: false,
                },
                yAxis:{
                    type:'value',
                    axisLabel: {
                        formatter:function (val){return (val*100).toFixed(2)+'%'},
                        fontSize:14,color:'#333'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter:function (params) {
                        var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                        for(let i=0;i<params.length;i++){
                            htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>=0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'</td></tr>';
                        }
                        htmlStr+='</table></div>';
                        return htmlStr;
                    }
                },
                series:[]
            },
        }
    },
    mounted() {
        this.getProductSecurityProportion()
        this.getProductTypeProportion()
    },
    methods: {
        getProductSecurityProportion() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetProductSecurityProportion, {
                ProductCode: vm.ProductInfo.name, //基金编号
                DealDate: vm.ProductInfo.value
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data
                    let activeColor = ''
                    let seriesData = []
                    xdata.nameList.forEach((item,i) => {
                        if(item == 'CTA策略') {
                            activeColor = '#4F81BD'
                        } else if(item == '股票多头') {
                            activeColor = '#C0504D'
                        } else if(item == '流动性') {
                            activeColor = '#F79646'
                        } else if(item == '市场中性') {
                            activeColor = '#9BBB59'
                        } else if(item == '套利策略') {
                            activeColor = '#8064A2'
                        } else if(item == '债券策略') {
                            activeColor = '#4BACC6'
                        }
                        seriesData.push({
                            value: xdata.dataList[0][i],
                            itemStyle: {color: activeColor}
                        })
                    })
                    vm.optionBdzb.xAxis.data = xdata.dateList
                    vm.optionBdzb.series[0].data = seriesData
                }
            }).catch(err => { })
        },
        getProductTypeProportion() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetProductTypeProportion, {
                ProductCode: vm.ProductInfo.name, //基金编号
                DealDate: vm.ProductInfo.value,
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data
                    let seriesData = [{
                        name: '',
                        type: 'pie',
                        radius: '75%', //饼图的半径大小'60%'
                        center: ['40%', '50%'], //饼图的位置
                        label: { //饼图图形上的文本标签
                            normal: {
                                show: true,
                                textStyle:{fontSize: 14,fontWeight:500},
                                formatter: '{b}：{d}%'
                            }
                        },
                        itemStyle:{borderColor:'#fff',borderWidth:2},
                        data:[]
                    }]
                    let color = ['#4F81BD','#C0504D','#9BBB59','#8064A2','#4BACC6','#F79646']
                    xdata.dateList.forEach((item,i) => {
                        seriesData[0].data.push({
                            name:item,
                            value:xdata.dataList[0][i],
                            label:{
                                normal:{
                                    position:'outside',
                                    textStyle:{color:'inherit'}
                                }
                            }
                        })
                    })
                    vm.$commonEcharts.echartsNormalPie('clzb',seriesData,'20%',color)
                }
            }).catch(err => { })
            // 获取周报策略历史仓位
            vm.$http.post(vm.$apiPath.GetWeeklyPositionList,{
                ProductCode: vm.ProductInfo.name
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    // vm.weeklyArchives = res.data.data
                    vm.optionLscw.xAxis.data = res.data.data.dateList
                    let seriesData=[];
                    res.data.data.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name: val,
                            type: 'line',
                            symbol:'circle',showSymbol: false,symbolSize:8,areaStyle:{opacity:1},stack: 'Total',
                            data: res.data.data.dataList[ind],
                        })
                    })
                    vm.optionLscw.series=seriesData;
                }
            }).catch(err=>{})
        },

    }
}
</script>

<style lang="less" scoped>
.positionAnalysis {
    &-card{
        width:100%;display: flex;
        &-left {position: relative;width:50%;height:100%;padding-right:20px;}
        &-left::after {content: "";width: 2px;height: 100%;background: @cardTitBg;position: absolute;right: 0;top: 50%;transform: translateY(-50%);}
        &-right{width:50%;height:100%;padding-left:20px;}
    }
    &-legend {
        display: flex;justify-content: center;
        li {
            margin: 0 10px;font-size:12px;display: flex;align-items:center;
            span {display: inline-block;width: 23px;height: 13px;background: #4F81BD;border-radius: 3px;margin-right: 8px;}
        }
        li:nth-child(2) span {background: #C0504D;}
        li:nth-child(3) span {background: #F79646;}
        li:nth-child(4) span {background: #9BBB59;}
        li:nth-child(5) span {background: #8064A2;}
        li:nth-child(6) span {background: #4BACC6;}
    }
}

</style>